<template>
    <div>
          <el-dialog
            title="优惠券批量操作记录"
            :visible.sync="showDialog"
            width="60%"
            :before-close="handleClose"
            >
               <div class="specialReminder"> 
                 <i class="el-icon-warning remindIcon"></i>
                 <div class="ml10">
                    <div>导入的文件上传后，系统保存180天，过期自动删除</div>
                 </div>
              </div>
              <el-row >
                 <el-table ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%" >
                    <el-table-column type="index" label="序号" width="80" ></el-table-column>
                    <el-table-column prop="applyTime" label="操作内容"    width="250px"> </el-table-column>
                    <el-table-column prop="operator" label="操作状态"  width="100px"> </el-table-column>
                    <el-table-column prop="fileName" label="提交时间"  show-overflow-tooltip=""  width="150px"> </el-table-column>
                    <el-table-column prop="exportOperator" label="提交人"   width="180px"> </el-table-column>
                    <el-table-column prop="exportTime" label="操作地址"  width="200px" > </el-table-column>
                    <el-table-column prop="file" label="文件"  show-overflow-tooltip=""  width="150px"> </el-table-column>
                    <el-table-column prop="exportTime" label="操作" fixed="right" width="250px">
                        <template slot-scope="scope">
                              <div class="btnBox">
                                 <div class="toolBtn"><a :href="scope.row.fileUrl" target="_blank">下载源文件</a></div>
                                 <div class="toolBtn"><a :href="scope.row.changeDetailUrl" target="_blank">下载修改明细</a></div>
                              </div>
                        </template>
                    </el-table-column>
                    
                  </el-table>
                      <div class="footerBox" v-if="total>10">
                        <!-- 分页区域 -->
                        <el-pagination
                          @size-change="handleSizeChange"
                          @current-change="handleCurrentChange"
                          :current-page.sync="queryInfo.currPage"
                          :page-sizes="[10, 20, 30, 50]"
                          :page-size="queryInfo.pageSize"
                          layout="total, sizes, prev, pager, next, jumper"
                          :total="total"
                        ></el-pagination>
                      </div>
              </el-row>
             <span slot="footer" class="dialog-footer">
                <!-- <el-button @click="dialogVisible = false">取 消</el-button> -->
                <!-- <el-button type="primary" @click="confirm">确 定</el-button> -->
            </span>
          </el-dialog>
    </div>
</template>

<script>
export default {
    data(){
        return {
            total:2,
           showDialog:false,
           tableData:[
            {
               applyTime:'导入券码批量延长有效期10天',
               operator:'已完成',
               fileName:'2023/08/16 15:28:41',
               exportOperator:'测试/00002',
               exportTime:'安徽省合肥市',
               file:'优惠券批量操作导入.xls',
               fileUrl:"https://s3plus.sankuai.com/bucket1/2023/08/16/152815/NXe9a4xUNCEbXUlS/%E4%BC%98%E6%83%A0%E5%88%B8%E6%89%B9%E9%87%8F%E6%93%8D%E4%BD%9C%E5%AF%BC%E5%85%A5.xls?AWSAccessKeyId=SRV_5rurjvtz5vilFKEnTcLRcqgeouw0W4Kf&Expires=1692262002&Signature=zd6ezr%2B26gMxLMmRWzGmKGnI59g%3D",
               changeDetailUrl:'https://s3plus.sankuai.com/bucket1/%E4%BC%98%E6%83%A0%E5%88%B8%E4%BF%AE%E6%94%B9%E6%98%8E%E7%BB%86_615468_1692170945425.xlsx?AWSAccessKeyId=SRV_5rurjvtz5vilFKEnTcLRcqgeouw0W4Kf&Expires=1692261908&Signature=3o3unDGdI6kjAbCsT%2BCyIJbYXKw%3D',
            },
             {
               applyTime:'导入券码批量延长有效期10天',
               operator:'已完成',
               fileName:'2023/08/16 15:28:41',
               exportOperator:'测试/00002',
               exportTime:'安徽省合肥市',
               file:'优惠券批量操作导入.xls',
               fileUrl:"https://s3plus.sankuai.com/bucket1/2023/08/16/152815/NXe9a4xUNCEbXUlS/%E4%BC%98%E6%83%A0%E5%88%B8%E6%89%B9%E9%87%8F%E6%93%8D%E4%BD%9C%E5%AF%BC%E5%85%A5.xls?AWSAccessKeyId=SRV_5rurjvtz5vilFKEnTcLRcqgeouw0W4Kf&Expires=1692262002&Signature=zd6ezr%2B26gMxLMmRWzGmKGnI59g%3D",
               changeDetailUrl:'https://s3plus.sankuai.com/bucket1/%E4%BC%98%E6%83%A0%E5%88%B8%E4%BF%AE%E6%94%B9%E6%98%8E%E7%BB%86_615468_1692170945425.xlsx?AWSAccessKeyId=SRV_5rurjvtz5vilFKEnTcLRcqgeouw0W4Kf&Expires=1692261908&Signature=3o3unDGdI6kjAbCsT%2BCyIJbYXKw%3D',
            },
           ],
           queryInfo:{
            pageSize: 10,
            currPage: 1,
            condition:{},
          },
        }
    },
     props:{
        dialogRecordVisible:{
            type: Boolean,
            default:false,
        }
     },
     watch:{
        dialogRecordVisible:{
            handler(newVal,oldVal){
                this.showDialog = newVal
            },
            deep:true,
            immediate:true,
        }
     },
      methods:{
        //下载文件
        downLoadFile(row){
        //window.open(downloadPath)
        },
        handleClose(){
             this.$emit('recordDialogClose',false)
             this.showDialog = false
        },
        // 监听 pagesize改变的事件
        handleSizeChange(newSize) {
        this.queryInfo.pageSize = newSize;
        //   this.getListData();
        },
        // 监听 页码值 改变事件
        handleCurrentChange(newSize) {
        this.queryInfo.currPage = newSize;
        //   this.getListData();
        },
     }
}
</script>

<style lang="less" scoped>
 /deep/ .el-table th>.cell{
    font-size: 15px;
    color: #222;
    font-weight: 500;
 }
 /deep/ .el-dialog__header{
    border-bottom: 1px solid #e5e5e5;
 }
 .toolBtn{
    color: #f59a23;
    font-size: 14px;
    cursor: pointer;
 }
 /deep/ .el-table th, /deep/ .el-table tr{
    font-size: 14px;
    color: #222;
 }
 .statusColor {
    color: green;
 }
 .specialReminder{
    padding:10px 15px;
    background: #fffae6;
    border: 1px solid #ffd100;
    border-radius: 7px;
    display: flex;
    margin-bottom: 10px;
    font-size: 15px;
    color: #666;
}
.remindIcon{
 color: #fb7807;
 font-size: 17px;
}
.toolBtn{
    padding: 0 10px;
    color: rgb(245,167,86);
    font-size: 14px;
    text-align: center; 
    position: relative;
    cursor: pointer;
}
.toolBtn::after{
  content: "|";
  color: #ddd;
  position: absolute;
  right: 0;
}
.toolBtn:nth-last-child(1)::after{
    content: '';
}
.btnBox{
    display: flex;
    flex-wrap: wrap;
}
</style>